import { forwardRef, ReactNode } from "react";

import Current from "./Current";
import Home from "./Home";
import { LinkbarItem } from "./Linkbar";
import styles from "./Linkbar.module.css";
import Parent from "./Parent";

const LinkbarExpanded = forwardRef<
  HTMLDivElement,
  {
    items?: LinkbarItem[];
    currentLabel: ReactNode;
    currentAsH1?: boolean;
    "data-testid"?: string | undefined;
  }
>(
  (
    {
      items = [],
      currentLabel,
      currentAsH1 = false,
      "data-testid": dataTestId,
    },
    ref
  ) => {
    return (
      <div
        data-testid={dataTestId}
        className={styles["linkbar-expanded"]}
        ref={ref}
      >
        <Home />
        <div className={styles["linkbar-expanded-inner"]}>
          {items.map(({ label, to }, i) => {
            return <Parent key={i} label={label} to={to} />;
          })}
          <Current label={currentLabel} asH1={currentAsH1} />
        </div>
      </div>
    );
  }
);

export default LinkbarExpanded;
